import { render } from "./PricingAnalysisReport.vue?vue&type=template&id=545b5e39&scoped=true"
import script from "./PricingAnalysisReport.vue?vue&type=script&lang=js"
export * from "./PricingAnalysisReport.vue?vue&type=script&lang=js"

import "./PricingAnalysisReport.vue?vue&type=style&index=0&id=545b5e39&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b5e39"]])

export default __exports__